module.exports = __webpack_public_path__ + "images/product-badges/product-badge-review-9003b8a9b778b6ee9f377e272095ecf8.webp";